import React, { Component } from 'react'
import styles from './index.module.less'
import Utils from '../../lib/utils'
import classNames from 'classnames'

const TagMap = {
  '独播': 'red',
  '直播': 'red',
  '直播中': 'red',
  '出品': 'red',
  '自频道': 'red',
  'VIP': 'vip',
  '会员用券': 'vip',
  '用券': 'vip',
  '会员免费': 'vip',
  '1080P': 'vip',
  '会员打折': 'vip',
  '预告': 'blue',
  '广告': 'gray'
}

/**
 * susummaryType类型对应的class名称
 */
const summaryTypeMap = {
  'UPDATE_STATUS': '',
  'SCORE': 'pack_score',
  'DOUBAN_SCORE': 'pack_score'
}
const tagToClassName = type =>
  classNames(styles.avatarItem, {
    [styles.tag_red]: type === 'red',
    [styles.tag_vip]: type === 'vip',
    [styles.tag_gray]: type === 'gray',
    '': type === 'blue'
  })

/**
 * 角标构造
 * 具体颜色和文字
 * @param {type:'red', text:''} props
 */
function TagLabe (data) {
  if (!data || !data.rightTagText) {
    return ''
  }
  const _type = TagMap[data.rightTagText] || 'red' // data.rightTagClass ? data.rightTagClass : styles.blue
  const _className = tagToClassName(_type)
  return (
    <span className={styles.p_rt}>
      <span className={`${styles.pack_tag} ${_className}`}>{data.rightTagText}</span>
    </span>
  )
};

/**
 *
 * @param {Boolean} isRank
 * @param {number} index
 */
function RankIcon (isRank, index) {
  return (
    <span className={styles.p_lt}>
      {
        isRank ? <span className={`${styles.pack_rank} rank_${index + 1}`}>No.{index + 1}</span> : ''
      }
    </span>
  )
}

function SummaryBar (summaryType, summary) {
  const _className = summaryTypeMap[summaryType] || ''
  return (
    <span className={styles.p_rb}>
      <span className={styles[_className]}>{summary}</span>
    </span>
  )
}

function BottomInfo (data, isOneLineTitle, hideSubTitle) {
  return (
    <div className={styles.info_list}>
      <div className={`${styles.title}  ${isOneLineTitle ? styles.short_title : ''}`}>
        <a
          {...Utils.getItemSpmData(data, true)}
          {...Utils.getATagProps(data, true)}>{data.title}</a>
      </div>
      {
        hideSubTitle && !isOneLineTitle
          ? '' : <div className={styles.subtitle}>
            {data.subTitle}
          </div>
      }

    </div>
  )
}

class Pack extends Component {
  static defaultProps = {
    data: null, // 具体数据
    type: 'vertical', // type 是否是横版 horizontal -- 横版本 vertical-竖版 focus-8+1焦点 默认横版
    rank: false, // 是否是排行
    index: 0, // 当前索引
    isOneLineTitle: 0,
    hideSubTitle: false,
    spm: ''
  }

  constructor (props) {
    super(props)
    // 是否是8+1类型
    this.isFocus = props.type === 'focus'
  }

  render () {
    const _outClass = this.props.type === 'vertical' ? styles.yk_pack_v : this.props.type === 'focus' ? styles.yk_pack_focus : styles.yk_pack
    let _imgUrl = this.props.data.gifImg ? this.props.data.gifImg : this.props.data.img
    _imgUrl = this.isFocus ? Utils.imageOss(_imgUrl, { type: 'crop', w: 490, h: 276 }) : Utils.imageOss(_imgUrl)
    return (
      <div className={_outClass} type={this.props.type}>
        {
          this.isFocus
            ? <img
              src={_imgUrl}
              className={`${styles.focus_bg} blur`} /> : ''
        }
        <div className={styles.pack_cover}>
          <a
            {...Utils.getItemSpmData(this.props.data)}
            {...Utils.getATagProps(this.props.data, true)}>
            <img src={_imgUrl} />
            <div className={styles.bg} />

            { RankIcon(this.props.rank, this.props.index) }

            { TagLabe(this.props.data) }

            { SummaryBar(this.props.data.summaryType, this.props.data.summary) }
          </a>
        </div>
        {
          BottomInfo(
            this.props.data,
            this.props.isOneLineTitle,
            this.props.hideSubTitle)
        }
      </div>
    )
  }
}
export default Pack
